// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "react-hot-toast";

// 🧭 Client Pages
import Homepage from "./home";
import SignupPage from "./register";
import LoginPage from "./LoginPage";
import WalletApp from "./clients/dashboard";
import DepositPage from "./clients/deposit";
import WithdrawalPage from "./clients/withdrawal";
import EarnPage from "./clients/package";
import Profile from "./clients/Profile";

// 🛠️ Admin Pages
import AdminLogin from "./admin/admin_login";
import UserDetail from "./admin/UserDetail";
import Users from "./admin/Users";


// 🔒 User Protected Route
const ProtectedRoute = () => {
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to="/login" replace />;
  return <Outlet />;
};

// 🔑 Admin Protected Route
const PrivateAdminRoute = () => {
  const email = localStorage.getItem("email");
  const password = localStorage.getItem("password");

  const isAuthenticated =
    email === "welthandel.vercel@vercel.com" &&
    password === "welthandel.vercel12345000";

  return isAuthenticated ? <Outlet /> : <Navigate to="/admin_login" replace />;
};

// ⚙️ Main App Component
function App() {
  return (
    <Router>
      <Toaster position="top-right" reverseOrder={false} />

      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Homepage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<SignupPage />} />
        <Route path="/admin_login" element={<AdminLogin />} />

        {/* 🧍 User Routes (Protected) */}
        <Route path="/user" element={<ProtectedRoute />}>
          <Route path="wallet" element={<WalletApp />} />
          <Route path="deposit" element={<DepositPage />} />
          <Route path="withdraw" element={<WithdrawalPage />} />
          <Route path="package" element={<EarnPage />} />
          <Route path="profile" element={<Profile />} />
        </Route>

        {/* 👨‍💼 Admin Routes (Private) */}
        <Route path="/admin" element={<PrivateAdminRoute />}>
   
          <Route path="users" element={<Users />} />
          <Route path="users/:id" element={<UserDetail />} />
 
   
        </Route>

        {/* Catch-All Redirect */}
        {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
      </Routes>

      {/* <GoogleTranslate /> */}
    </Router>
  );
}

export default App;
